import Vue, { CreateElement } from '@src/vue'
import { VNode } from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Tooltip as ElementUITooltip } from 'element-ui'
import { isMobileBrowser } from '@src/util/functions'

import './tooltip.sass'

@Component
export class Tooltip extends Vue {

  // a text, or the elements of a richer tooltip (they go to the content slot of the element-ui tooltip)
  @Prop({ type: [String, Object], required: true })
  content: string | VNode
  constructor () {
    super()
  }

  render (h: CreateElement) {
 /*   if (this.isMobilePage) {
      return (<div class={'tooltip-mobile-wrapper'}>
        <div>{this.icon}</div>
        <div class={'tooltip-mobile-text'}>{this.content}</div>
      </div>)
    }*/
    return (<ElementUITooltip
        effect='dark'
        content={typeof this.content === 'string' ? this.content : undefined}
        popper-class='custom-tooltip'
        enterable={false}
        disabled={isMobileBrowser()}
      >
        {this.$slots.default}
        {typeof this.content !== 'string' && <div slot='content'>{this.content}</div>}
    </ElementUITooltip>)
  }
}
